import MenuConfiguration from "./MenuConfiguration";

export default MenuConfiguration;

